import styled from 'styled-components'
import { media } from '../../utils/media'

export const SplashContainer = styled.div(({ theme }) => ({
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    background: theme.colors.Black,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    position: 'relative',
    overflow: 'hidden'
}))

export const PromoLogoContainer = styled.div`
    z-index: 2;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    color: #fff;
    gap: 24px;
`

export const SplashImage = styled.img`
    width: 60vw;
    max-width: 183px;
    min-width: 160px;
    height: auto;
    @media ${media.tablet} {
        max-width: 183px;
    }
    @media ${media.laptop} {
        max-width: 183px;
    }
`

export const PromoScreenContainer = styled.div`
    position: relative;
    width: ${({isMobile}) => isMobile ? '100vw' : '379px'};
    height: ${({isMobile}) => isMobile ? 'auto' : '724px'};
    min-height: ${({isMobile}) => isMobile ? '100%' : 'unset'};
    max-height: ${({isMobile}) => isMobile ? 'none' : '90vh'};
    overflow-y: auto;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    background-color: ${({ theme, isMobile }) =>
        isMobile ? 'transparent' : theme.app.background};
    border-radius: ${({isMobile}) => isMobile ? '0px' : '16px'};
    padding: ${({isMobile}) => isMobile ? '32px 24px' : '48px'};
    gap: ${({isMobile}) => isMobile ? '24px' : '0'};
`
export const PromoScreenBottomContainer = styled.div`
    width: 100%;
    z-index: 2;
    text-align: center;
`

export const PromoSplashImage = styled.img`
    width: 122px;
    height: 48px;
    object-fit: contain;
    position: relative;
    z-index: 2;
    align-items: center;
`

export const LogoContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    row-gap: 14px;
    margin-top: 0;
    width: 100%;
    z-index: 2;
    @media ${media.tablet} {
        row-gap: 32px;
        margin-bottom: 2.5rem;
    }
    @media ${media.laptop} {
        row-gap: 32px;
        margin-bottom: 3rem;
    }
    @media (width: 1920px) {
        row-gap: 32px;
    }
`
export const Overlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5); /* darken background */
    z-index: 1;
`

export const VideoBox = styled.div`
    width: 100vw;
    height: 100vh;
    background: ${({theme}) => theme.app.background};
    opacity: 0.64;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    overflow: hidden;
    pointer-events: none;
`
